export default "__VITE_ASSET__fjRdBZaI__"